import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={32}
    height={20}
    viewBox="0 0 32 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V14C32 17.3137 29.3137 20 26 20H6C2.68629 20 0 17.3137 0 14V6Z"
      fill="white"
    />
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V14C32 17.3137 29.3137 20 26 20H6C2.68629 20 0 17.3137 0 14V6Z"
      fill="white"
      fillOpacity={0.4}
    />
    <g clipPath="url(#clip0_21_68)">
      <path
        d="M14.9134 10.6877V13.3727H14.0472V6.73228H16.2992C16.8478 6.73228 17.3675 6.93438 17.7717 7.3097C18.1759 7.65616 18.378 8.17585 18.378 8.7244C18.378 9.27296 18.1759 9.76377 17.7717 10.1391C17.3675 10.5144 16.8766 10.7165 16.2992 10.7165L14.9134 10.6877ZM14.9134 7.54068V9.85039H16.357C16.6745 9.85039 16.9921 9.7349 17.1942 9.50393C17.6562 9.07086 17.6562 8.34908 17.2231 7.916L17.1942 7.88713C16.9633 7.65616 16.6745 7.5118 16.357 7.54068H14.9134Z"
        fill="#5F6368"
      />
      <path
        d="M20.3701 8.69554C21.0053 8.69554 21.4961 8.86877 21.8714 9.21523C22.2467 9.56168 22.4199 10.0236 22.4199 10.6011V13.3727H21.6116V12.7375H21.5827C21.2362 13.2572 20.7454 13.5171 20.168 13.5171C19.6772 13.5171 19.2441 13.3727 18.8976 13.084C18.5801 12.7953 18.378 12.3911 18.378 11.958C18.378 11.4961 18.5512 11.1207 18.8976 10.832C19.2441 10.5433 19.7349 10.4278 20.3123 10.4278C20.832 10.4278 21.2362 10.5144 21.5538 10.7165V10.5144C21.5538 10.2257 21.4383 9.93701 21.2074 9.76378C20.9764 9.56168 20.6877 9.4462 20.3701 9.4462C19.8793 9.4462 19.5039 9.6483 19.2441 10.0525L18.4934 9.59055C18.9554 8.98426 19.5617 8.69554 20.3701 8.69554ZM19.273 11.9869C19.273 12.2179 19.3885 12.42 19.5617 12.5354C19.7638 12.6798 19.9948 12.7664 20.2257 12.7664C20.5722 12.7664 20.9186 12.6221 21.1785 12.3622C21.4672 12.1024 21.6116 11.7848 21.6116 11.4383C21.3517 11.2362 20.9764 11.1207 20.4856 11.1207C20.1391 11.1207 19.8504 11.2074 19.6194 11.3806C19.3885 11.5249 19.273 11.727 19.273 11.9869Z"
        fill="#5F6368"
      />
      <path
        d="M27.0971 8.8399L24.2388 15.3937H23.3727L24.4409 13.1129L22.5643 8.86877H23.4882L24.8451 12.1312H24.874L26.2021 8.86877H27.0971V8.8399Z"
        fill="#5F6368"
      />
      <path
        d="M11.4777 10.1102C11.4777 9.85039 11.4488 9.59055 11.4199 9.3307H7.81102V10.8031H9.86089C9.77428 11.2651 9.51444 11.6982 9.11024 11.958V12.9108H10.3517C11.0735 12.2467 11.4777 11.2651 11.4777 10.1102Z"
        fill="#4285F4"
      />
      <path
        d="M7.81102 13.8346C8.85039 13.8346 9.71654 13.4882 10.3517 12.9108L9.11024 11.958C8.76378 12.189 8.33071 12.3333 7.81102 12.3333C6.8294 12.3333 5.96325 11.6693 5.67454 10.7454H4.4042V11.727C5.06824 13.0262 6.36745 13.8346 7.81102 13.8346Z"
        fill="#34A853"
      />
      <path
        d="M5.67454 10.7454C5.50131 10.2835 5.50131 9.76378 5.67454 9.27296V8.29134H4.4042C3.85564 9.35958 3.85564 10.6299 4.4042 11.727L5.67454 10.7454Z"
        fill="#FBBC04"
      />
      <path
        d="M7.81102 7.7139C8.35958 7.7139 8.87927 7.916 9.28346 8.29133L10.3806 7.19422C9.68766 6.55905 8.76378 6.18372 7.8399 6.21259C6.39633 6.21259 5.06824 7.02099 4.43307 8.3202L5.70341 9.30183C5.96325 8.37794 6.8294 7.7139 7.81102 7.7139Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_21_68">
        <rect
          width={23.0971}
          height={11}
          fill="white"
          transform="translate(4 5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
